import React, {useCallback, lazy, Suspense} from 'react';
import axios from 'axios';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';

const TopListComponent = lazy(() => import('@quantgate-systems/toplist'));

function TopListScreen(props) {
  const port = useSelector(state => state.app?.port);
  const token = useSelector(state => state.user?.token);
  const {state} = useLocation();
  const refreshToken = useSelector(state => state.user?.refreshToken);

  const onItemClicked = useCallback(instrument => {
    console.log('port', port);
    if (port) {
      axios
        .post(`http://localhost:${port}/select?Symbol=${instrument?.symbol}`, {})
        .then(res => console.log(res.data))
        .catch(err => console.log(err));
    }
    console.log('instrument', instrument);
  }, []);

  if (state?.username && state?.password) {
    return (
      <div>
        <Suspense fallback={<div>Page is loading...</div>}>
          <TopListComponent
            brokerName="signals-only"
            onItemClick={onItemClicked}
            credentials={{UserName: state?.username, Password: state?.password}}
          />
        </Suspense>
      </div>
    );
  } else {
    console.log('using tokens', token, refreshToken);
    return (
      <div>
        <Suspense fallback={<div>Page is loading...</div>}>
          <TopListComponent
            brokerName="signals-only"
            onItemClick={onItemClicked}
            token={token}
            refreshToken={refreshToken}
          />
        </Suspense>
      </div>
    );
  }
}

export default TopListScreen;
